import { Autocomplete, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const rollPositionCodes = [
	{ Code: "A", Name: "Any", Color: "#ab9680" },
	{ Code: "T", Name: "Top", Color: "#fad215" },
	{ Code: "B", Name: "Bottom", Color: "#a770b2" },
];

type Props = {
	label: string;
	value: string | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
	required?: boolean;
};

export const RollPositionSelector = ({
	label,
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
	required = false,
}: Props) => {
	const selectedPosition =
		rollPositionCodes.find((code) => code.Code === value) || null;

	return (
		<Autocomplete
			id="roll-position-selector"
			clearOnEscape
			autoHighlight
			options={rollPositionCodes}
			getOptionLabel={(option) => option.Name}
			renderInput={(params) => (
				<TextField
					{...params}
					required={required}
					label={label}
					variant="outlined"
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					size="small"
					inputProps={{
						...params.inputProps,
						"data-test-id": "roll-position-selector",
					}}
				/>
			)}
			value={selectedPosition}
			onChange={(event, newValue) => {
				onChange(newValue?.Code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
